var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center ml-5"},[(_vm.checked)?_c('div',[_c('input',{attrs:{"type":"checkbox","checked":""}})]):_c('div',[_c('input',{attrs:{"type":"checkbox"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }